module.exports = __webpack_public_path__ + "img/frango.b070b7b7.svg";